"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _itemTypes = _interopRequireDefault(require("./itemTypes"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var backgroundOptions = [{
  value: 'default',
  label: 'None'
}, {
  value: 'corkboard',
  label: 'Corkboard'
}, {
  value: 'notebook',
  label: 'Notebook'
}, {
  value: 'tablet',
  label: 'Tablet'
}];
var Builder = function Builder(props) {
  var _props$fields = props.fields,
    question = _props$fields.question,
    description = _props$fields.description,
    items = _props$fields.items,
    itemTypes = _props$fields.itemTypes,
    isItemsExpanded = _props$fields.isItemsExpanded,
    completeCondition = _props$fields.completeCondition,
    minimumNumber = _props$fields.minimumNumber,
    isBackgroundExpanded = _props$fields.isBackgroundExpanded,
    background = _props$fields.background;
  var renderItem = function renderItem(item, itemField) {
    var element = _itemTypes["default"][item.type.value];
    var defaultValue = element.defaultLabel || element.name;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
      field: item.label,
      label: "Item",
      isWysiwyg: true,
      wysiwygProps: {
        autofocus: 'end',
        selectAllOnFocus: item.label.value === defaultValue
      }
    }), itemField);
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
    field: question,
    label: "Question"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
    content: question.value,
    onChange: question.onChange,
    selectAllOnFocus: question.value === _settings.initialValues.question
  })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
    field: description,
    label: "Description"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
    content: description.value,
    onChange: description.onChange
  })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
    title: /*#__PURE__*/_react["default"].createElement("span", null, "Items ", /*#__PURE__*/_react["default"].createElement("span", {
      className: "badge"
    }, items.length)),
    type: "primary",
    show: isItemsExpanded.value,
    handleClick: function handleClick(show) {
      return isItemsExpanded.onChange(show);
    },
    isError: (0, _cccisdSurveyCommon.checkForErrors)([items, itemTypes])
  }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.DragDropElements, {
    constant: "items",
    elements: items,
    elementTypes: _itemTypes["default"],
    elementFields: itemTypes,
    renderElement: renderItem,
    dragHint: "Drag items here",
    moveOnTab: true,
    blockType: "success"
  })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
    title: "Background",
    type: "primary",
    show: isBackgroundExpanded.value,
    handleClick: function handleClick(show) {
      return isBackgroundExpanded.onChange(show);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].bgWrapper
  }, backgroundOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: option.value,
      className: (0, _classnames2["default"])(_style["default"].bgOption, _style["default"][option.value], _defineProperty({}, _style["default"].selected, option.value === background.value)),
      onClick: function onClick() {
        return background.onChange(option.value);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].inside
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
    title: "Advancing",
    type: "primary",
    show: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _common["default"].lastRow
  }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
    field: completeCondition,
    label: "Before advancing, must complete:"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].indent
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "radio",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "radio"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(completeCondition), {
    value: "all",
    checked: completeCondition.value === 'all'
  })), ' ', "all list items")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "radio"
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "radio"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(completeCondition), {
    value: "minimum",
    checked: completeCondition.value === 'minimum'
  })), ' ', "at least", ' ', /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: "form-control input-sm",
    style: {
      display: 'inline-block',
      width: '60px',
      height: '1.8em'
    },
    type: "number"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(minimumNumber))), ' ', "list item(s)")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "radio"
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "radio"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(completeCondition), {
    value: "none",
    checked: completeCondition.value === 'none'
  })), ' ', "no list items")))))));
};
Builder.propTypes = {
  fields: _propTypes["default"].object
};
var _default = exports["default"] = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withTemplate: true,
  withAccommodations: true,
  withAdjustedPlayerSettings: true,
  withBubbleMessages: true,
  withVisibilityConditions: true
})(Builder);